<template>
    <div class="login">
        <div class="login_logo">
            <img class="login_logo_img" src="@/assets/images/login/logo.png" />
        </div>
        <div class="login_main">
            <div class="main_left">
                <img class="main_img" src="@/assets/images/login/haibao.png" />
            </div>
            <div class="main_right">
                <div class="login-form">
                    <div class="form-title">{{ systemName }}</div>
                    <div class="form-tab">
                        <div class="form-tab-item" :class="{ active: tabIndex === 0 }" @click="tabIndex = 0">扫码登录</div>
                        <div class="form-tab-item" :class="{ active: tabIndex === 1 }" @click="tabIndex = 1">密码登录</div>
                    </div>

                    <div v-if="tabIndex === 0" class="item flex flex-ai-c">
                        <!-- <img class="qr-code" :src="qrUrl" alt="QR Code" @click="generate()" /> -->
                        <div class="qr-code-container" v-if="qrCodeUrl">
                            <div class="iframe-wrapper">
                                <iframe :src="qrCodeUrl" frameborder="0"></iframe>
                            </div>
                        </div>

                        <div class="qr-code-container" v-else>正在加载二维码...</div>
                        <el-button class="mt20" type="primary" size="large" link @click="registeredSubmit()">
                            注册
                        </el-button>
                    </div>

                    <div v-if="tabIndex === 1" class="item">
                        <div class="form-item">
                            <i class="icon user"></i>
                            <el-input v-model="loginForm.userName" placeholder="请输入账号" />
                        </div>
                        <div class="form-item">
                            <i class="icon lock"></i>
                            <el-input v-model="loginForm.passWord" placeholder="请输入密码" type="password" show-password
                                @keyup.enter="loginSubmit()" />
                        </div>
                        <!-- <div class="form-item captcha">
                            <i class="icon code"></i>
                            <el-input v-model="loginForm.captcha" placeholder="请输入验证码" @keyup.enter="loginSubmit()" />
                            <img class="captcha-img" :src="captchaImgUrl" @click="refreshCaptcha" />
                        </div> -->
                        <button class="login-btn" @click="loginSubmit()" :disabled="loading">登录</button>
                        <div class="flex flex-jc-c mt20">
                            <el-button class="mr20" type="primary" size="large" link @click="registeredSubmit()">
                                注册
                            </el-button>
                            <el-button size="large" link @click="forgotSubmit()">
                                忘记密码
                            </el-button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup>
import { reactive, ref, onMounted, watch } from 'vue';
import { ElMessage } from 'element-plus';
import { useRouter, useRoute } from 'vue-router';
// import { useUserStore } from '@/store/user'; // Pinia store
import { SYSTEM_NAME, URL } from '@/constant/Const';
import { login, getRouteList, getloginimage, getLoginQrCode, getLoginOpenId, getLoginCallbackQr, userWxLogin } from "@/api/auth/login/index";
import { refreshRoutes } from '@/router';
import QRCode from 'qrcode'

const route = useRoute()
const router = useRouter();
// const userStore = useUserStore();

const systemName = SYSTEM_NAME;
const url = URL;

const loginForm = reactive({
    userName: '',
    passWord: '',
    captcha: '',
    uuid: '',
});
const tabIndex = ref(0);
const loading = ref(false);
const isWindows = ref(true);
const mainRightWidth = ref('23vw');
const mainInputWidth = ref('15vw');
const captchaImgUrl = ref('');

const loginRef = ref(null);
const qrUrl = ref(null);
const qrCodeUrl = ref(null);


watch(tabIndex, (newVal) => {
    if (newVal === 0) {
        generate();
    }
});
watch(
    () => route.query,
    () => {
        handleWxCallback()
    }
)
onMounted(() => {
    checkUserAgent();
    // refreshCaptcha();
    /* if (!code){
        return
    }else{
        login({code, state}).then(res => {
            console.log(res)
        })
    } */
    generate();
});
// 监听路由参数变化
const handleWxCallback = () => {
    const code = route.query.code
    const state = route.query.state

    if (code) {
        console.log('拿到微信code:', code)
        loading.value = true;
        // 调后端登录
        getLoginOpenId({ code }).then(res => {
            userWxLogin({ openId: res.data }).then(resp => {
                if (resp.code == 0) {
                    sessionStorage.setItem("token", resp.data.token);
                    sessionStorage.setItem("userInfo", JSON.stringify(resp.data));
                    getRouteList().then(result => {
                        if (result.data && result.data.length > 0) {
                            sessionStorage.setItem("menuList", JSON.stringify(result.data));
                            // userStore.setMenuList(result.data);
                            refreshRoutes();
                            router.replace('/quotation/index');
                        } else {
                            ElMessage.error('无路由数据，请联系管理员并重新登录！');
                            sessionStorage.clear();
                        }
                        loading.value = false;
                    }).catch(() => { loading.value = false; });
                } else {
                    tabIndex.value = 1;
                    loading.value = false;
                }
            }).catch(() => {
                tabIndex.value = 1;
                loading.value = false;
            });
        }).catch((err) => {
            console.log(err);
        });
    }
}

const generate = async () => {
    // const url = await QRCode.toDataURL('https://example.com?uuid=' + Date.now(), {
    // width: 200,
    // margin: 1,
    // errorCorrectionLevel: 'H',
    // })

    // qrUrl.value = url;
    getLoginQrCode().then(resp => {
        console.log(resp);
        const url = resp.data;
        console.log(url);

        qrCodeUrl.value = url;
    }).catch((err) => {
        console.log(err);

        // ElMessage.error('获取二维码失败，请稍后重试！');
    });
}

function checkUserAgent() {
    const userAgent = navigator.userAgent;
    if (userAgent.includes('Windows') || userAgent.includes('Win')) {
        isWindows.value = true;
    } else {
        isWindows.value = false;
        mainRightWidth.value = '70vw';
        mainInputWidth.value = '53vw';
    }
}

function refreshCaptcha() {
    loginForm.uuid = uuidCompact();
    captchaImgUrl.value = url + `/api/login/captcha?uuid=${loginForm.uuid}&t=${Date.now()}`;
}

function arrayBufferToBase64(buffer) {
    let binary = '';
    const bytes = new Uint8Array(buffer);
    for (let i = 0; i < bytes.byteLength; i++) {
        binary += String.fromCharCode(bytes[i]);
    }
    return window.btoa(binary);
}

function uuidCompact() {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
        const r = (Math.random() * 16) | 0;
        const v = c === 'x' ? r : (r & 0x3) | 0x8;
        return v.toString(16);
    });
}

function registeredSubmit() {
    router.push('/register');
    // ElMessage.success('注册');
}

function forgotSubmit() {
    router.push('/forgot');
    // ElMessage.success('忘记密码');
}

function loginSubmit() {
    if (!loginForm.userName || !loginForm.passWord) {
        ElMessage.error('请输入用户名和密码');
        return;
    }
    loading.value = true;
    login(loginForm).then(resp => {
        console.log(resp);

        if (resp.data) {
            sessionStorage.setItem("token", resp.data.token);
            sessionStorage.setItem("userInfo", JSON.stringify(resp.data));
            getRouteList().then(result => {
                if (result.data && result.data.length > 0) {
                    sessionStorage.setItem("menuList", JSON.stringify(result.data));
                    // userStore.setMenuList(result.data);
                    refreshRoutes();
                    router.replace('/quotation/index');
                } else {
                    ElMessage.error('无路由数据，请联系管理员并重新登录！');
                    sessionStorage.clear();
                }
                loading.value = false;
            }).catch(() => { loading.value = false; });
        } else {
            loading.value = false;
        }
    }).catch(() => { loading.value = false; });
}
</script>

<style lang="scss" scoped>
/* Login 样式 */
.login::v-deep {
    position: relative;
    width: 100vw;
    min-height: 100vh;

    background: #0064C8 url('@/assets/images/login/beijing.png') no-repeat center;
    background-size: cover;

    display: flex;
    flex-direction: column;
    align-items: center;

    /* logo 区 */
    .login_logo {
        margin-top: clamp(40px, 8vh, 90px);
        margin-bottom: clamp(40px, 6vh, 92px);
        display: flex;
        justify-content: center;

        .login_logo_img {
            width: 250px;
            height: auto;
        }
    }

    /* 主体卡片 */
    .login_main {
        width: 90%;
        max-width: 866px;
        min-height: 520px;
        padding: 20px;

        background: #ffffff;
        border-radius: 12px;

        box-sizing: border-box;
        display: flex;

        .main_left {
            width: 40%;
            height: 100%;

            .el-carousel {
                width: 100%;

            }

            .main_img {
                width: 100%;
                object-fit: cover;
                display: block;
            }
        }

        .main_right {
            flex: 1;
            box-sizing: border-box;
            padding: clamp(20px, 3vw, 40px);

            .login-form {
                width: 100%;
                max-width: 360px;
                margin: 0 auto;
                display: flex;
                flex-direction: column;
                align-items: stretch;

                .form-title {
                    text-align: center;
                    font-size: 22px;
                    font-weight: 600;
                    color: #333;
                    margin-bottom: 30px;
                    position: relative;
                }

                .form-tab {
                    display: flex;
                    justify-content: center;

                    .form-tab-item {
                        width: 50%;
                        cursor: pointer;
                        text-align: center;
                        font-size: 18px;
                        font-weight: 600;
                        color: #333;
                        margin-bottom: 30px;
                        position: relative;

                        &::after {
                            content: '';
                            display: block;
                            width: 100%;
                            height: 2px;
                            background: #e5e5e5;
                            margin: 12px auto 0;
                        }
                    }

                    .active {
                        color: #391A69;

                        &::after {
                            background: #391A69;
                        }
                    }
                }

                .item {
                    display: flex;
                    flex-direction: column;
                    align-items: stretch;
                }

                .qr-code {
                    width: 200px;
                    height: 200px;
                }

                .form-item {
                    display: flex;
                    align-items: center;
                    height: 44px;
                    border: 1px solid #e5e8ef;
                    border-radius: 4px;
                    padding: 0 12px;
                    margin-bottom: 16px;
                    box-sizing: border-box;

                    .el-input {
                        flex: 1;
                        border: none;
                        outline: none;
                        font-size: 14px;
                        color: #333;

                        &::placeholder {
                            color: #b0b4bd;
                        }

                        .el-input__wrapper {
                            box-shadow: none !important;
                        }
                    }

                    .icon {
                        width: 18px;
                        height: 18px;
                        margin-right: 8px;
                        background-size: contain;
                        background-repeat: no-repeat;

                        &.user {
                            background-image: url('@/assets/images/login/shuruzhanghao.png');
                        }

                        &.lock {
                            background-image: url('@/assets/images/login/shurumima.png');
                        }

                        &.code {
                            background-image: url('@/assets/images/login/shuruyanzhengma.png');
                        }
                    }
                }

                .captcha {

                    .captcha-img {
                        width: 90px;
                        height: 32px;
                        background: #e5e5e5;
                        border-radius: 4px;
                    }
                }

                .login-btn {
                    margin-top: 20px;
                    height: 44px;
                    background: #3a7afe;
                    border: none;
                    border-radius: 4px;
                    color: #fff;
                    font-size: 16px;
                    cursor: pointer;

                    &:hover {
                        background: #2f6fe4;
                    }
                }
            }

        }
    }

}

@media screen and (max-width: 992px) {
    .login {
        .login_main {
            .main_left {
                display: none;
            }

            .main_right {
                width: 100%;
            }
        }
    }
}

@media screen and (max-width: 576px) {
    .login_main {
        padding: 16px;
        border-radius: 8px;
    }
}

.qr-code-container {
    width: 300px;
    height: 300px;
    overflow: hidden;
    position: relative;
    text-align: center;
}

.qr-code-container::v-deep iframe {
    width: 100%;
    height: 450px;
    border: none;
    margin-top: -60px;
    transform: scale(0.7);
    transform-origin: center;
    overflow: hidden;
}
</style>